<template>
  <PreLoader />
  <SettingSidebar />
  <router-view />
  <Analytics />
</template>

<script lang="ts">
import { Analytics } from "@vercel/analytics/vue";
import { defineComponent, onMounted } from "vue";
import { useCurrentUser } from "./composables/useCurrentUser";
import settingService from "./services/setting";
import { applyGlobalSettings, normalizeSetting } from "./utils/settings";
import { isAuthenticated } from "./utils/auth";
import { syncCustomerDisplayBranding } from "./utils/posCustomerDisplay";

import PreLoader from "./components/Layouts/PreLoader.vue";
import SettingSidebar from "./components/Layouts/SettingSidebar.vue";

export default defineComponent({
  name: "App",
  components: {
    Analytics,
    PreLoader,
    SettingSidebar,
  },
  setup() {
    const { fetchCurrentUser } = useCurrentUser();

    const fetchSettings = async () => {
      try {
        const sData = await settingService.getSettings();
        const normalized = normalizeSetting(sData);

        applyGlobalSettings(normalized);
        syncCustomerDisplayBranding({
          site_name: normalized.site_name,
          logo: normalized.logo || "",
          company_phone: normalized.company_phone || "",
          company_address: normalized.company_address || "",
          company_email: normalized.company_email || "",
          note_to_customer: normalized.receipt_note_to_customer || "",
          currency_symbol:
            normalized.default_currency === "KHR" ? "៛" : "$",
          posters: normalized.customer_display_posters,
        });
      } catch (error) {
        console.error("Failed to load global settings:", error);
      }
    };

    onMounted(() => {
      if (isAuthenticated()) {
        fetchCurrentUser(true);
      }
      fetchSettings();
    });
  }
});
</script>
